export default class FormSubmit {
  constructor(element) {
    this.form = element
    this.submitButton = this.form.querySelector('.btn-toolbar *[type=submit]')

    this.init()
  }

  init() {
    this.form.addEventListener('submit', (e) => this.handleForm(e))
  }

  sendData() {
    if (!this.form.action) {
      return
    }

    const self = this

    const XHR = new XMLHttpRequest()

    // Bind the FormData object and the form element
    const FD = new FormData(this.form)

    const dest = this.form.parentNode

    // Define what happens on successful data submission
    XHR.addEventListener('load', function (event) {
      const response = JSON.parse(event.target.responseText)

      const oldErrors = self.form.querySelectorAll('.message.error, .message.required')
      oldErrors.forEach((element) => {
        element.remove()
      })

      if (response.status === 'error') {
        response.data.forEach((item) => {
          if (item.fieldName) {
            const formElement = self.form.querySelector(`#${self.form.id}_${item.fieldName}_Holder`)
            if (formElement) {
              const node = document.createElement('span')
              node.classList.add('message', item.messageType)
              node.innerHTML = item.message
              formElement.appendChild(node)
            }
          } else {
            const node = document.createElement('p')
            node.classList.add('message', item.messageType)
            node.innerHTML = item.message
            self.form.insertBefore(node, self.form.firstChild)
          }
        })
      } else {
        dest.innerHTML = response.data
      }

      // scroll to top
      dest.scrollIntoView({
        behavior: 'smooth',
      })

      // enable button
      if (self.submitButton) {
        self.submitButton.disabled = false
      }
    })

    // Define what happens in case of error
    XHR.addEventListener('error', function (event) {
      dest.innerHTML = '<p>Oops! Something went wrong.</p>'

      // scroll to top
      dest.scrollIntoView({
        behavior: 'smooth',
      })
    })

    // Set up our request
    XHR.open('POST', this.form.action)

    // Set headers
    XHR.setRequestHeader('x-requested-with', 'XMLHttpRequest')
    XHR.setRequestHeader('Accept', 'application/json')

    // The data sent is what the user provided in the form
    XHR.send(FD)
  }

  handleForm(e) {
    e.preventDefault()

    // Disable button after submit
    if (this.submitButton) {
      this.submitButton.disabled = true
    }

    this.sendData()
  }
}
